import type { ViewerContext } from "../../context/AuthContext";
import type { QapiFinding } from "./chartAudit";

export function canAccessQapiLeadershipWorkspace(
  viewerContext: ViewerContext | null,
): boolean {
  if (!viewerContext) return false;
  if (viewerContext.is_superadmin || viewerContext.role === "Admin") return true;
  return viewerContext.granted_capabilities?.includes("assign_tasks") ?? false;
}

export function summarizeQapiFindings(findings: QapiFinding[]) {
  const open = findings.filter((finding) => finding.status === "open").length;
  const inReview = findings.filter((finding) => finding.status === "in_review").length;
  const pipCreated = findings.filter((finding) => finding.status === "pip_created").length;
  const resolved = findings.filter((finding) => finding.status === "resolved").length;
  const highSeverity = findings.filter((finding) => finding.severity === "high").length;
  const active = open + inReview + pipCreated;

  return {
    total: findings.length,
    active,
    open,
    inReview,
    pipCreated,
    resolved,
    highSeverity,
  };
}
